import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./VideoReviews.module.scss";
import { useIntl } from "react-intl";

interface VideoReview {
  videoID: string;
  descr: string;
}

function VideoReviews() {
  const { formatMessage } = useIntl();
  const reviews: VideoReview[] = [
    { videoID: "j9MQ0ab525k", descr: formatMessage({ id: "wlp.reviews.1" }) },
    { videoID: "UfDt1sNjt_8", descr: formatMessage({ id: "wlp.reviews.2" }) },
    { videoID: "iyd3O-nw58E", descr: formatMessage({ id: "wlp.reviews.3" }) },
    { videoID: "xesFclq053Q", descr: formatMessage({ id: "wlp.reviews.4" }) },
    { videoID: "P7Pu6WOZiBw", descr: formatMessage({ id: "wlp.reviews.5" }) },
    { videoID: "aocN50rLDV4", descr: formatMessage({ id: "wlp.reviews.6" }) },
    { videoID: "qEkcBqYr4xQ", descr: formatMessage({ id: "wlp.reviews.7" }) },
    { videoID: "kkmfZ0h--aU", descr: formatMessage({ id: "wlp.reviews.8" }) },
    { videoID: "GijDVnrSRS0", descr: formatMessage({ id: "wlp.reviews.9" }) },
    { videoID: "JTYdWTfjCac", descr: formatMessage({ id: "wlp.reviews.10" }) },
  ];

  return (
    <section className={styles.section} id="video-reviews">
      <h3 className={`${styles.header} ${styles.headerAlign}`}>
        {formatMessage({ id: "wlp.reviews.heading" })}
      </h3>
      <div className={`${styles.card} ${styles.swiperVideo}`}>
        <Swiper
          slidesPerView={4}
          modules={[Navigation]}
          navigation
          loop
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 3,
              allowTouchMove: true,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 3,
              allowTouchMove: true,
              centeredSlides: true,
            },
            1025: {
              slidesPerView: 2,
              spaceBetween: 20,
              allowTouchMove: false,
            },
            1400: {
              slidesPerView: 2,
              spaceBetween: 20,
              allowTouchMove: false,
            },
            1600: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
          className={styles.swiper}
        >
          {reviews.map((review) => (
            <SwiperSlide key={review.videoID} className={styles.slide}>
              <a
                href={`https://www.youtube.com/watch?v=${review.videoID}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.slideLink}
              />
              <div className={styles.videoFrame}>
                <img
                  src={`https://i.ytimg.com/vi/${review.videoID}/hqdefault.jpg`}
                  alt={review.descr}
                  loading="lazy"
                />
                <span className={styles.playButton} aria-hidden="true" />
              </div>
              <span className={styles.slideTitle}>{review.descr}</span>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export { VideoReviews };
